const ACTIONS = {
  SET_FORECAST_DATA: "SET_FORECAST_DATA",
  SET_CURRENT_DATA: "SET_CURRENT_DATA",
  SET_ERROR: "SET_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  CLEAR_DATA: "CLEAR_DATA",
};

export default ACTIONS;
